import { z } from "zod";

export const confirmEmailSchema = z.object({
  code: z.string().min(6, {
    message: "Your one-time password must be 6 characters.",
  }),
});

export type ConfirmEmailFormData = z.infer<typeof confirmEmailSchema>;
